import React, { useState, useEffect } from 'react';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import {
    Input,
    InputGroup,
    Table,
    Button,
    Stack,
    Breadcrumb,
    Divider,
    Message,
    Modal,
    Col,
    useToaster,
    Form,
    FlexboxGrid,
    Container,
    SelectPicker,
    IconButton,
    CheckPicker,
    InputPicker,
    ButtonToolbar,
    Panel,
    Nav
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';

const MailConfig = () => {

    const [activeKey, setActiveKey] = useState('content1');
    const handleNavSelect = (eventKey) => {
        setActiveKey(eventKey);
    };
    const [activeKey1, setActiveKey1] = useState('content1');
    const handleNavSelect1 = (eventKey) => {
        setActiveKey1(eventKey);
    };
    const [visible, setVisible] = React.useState(false);
    const handleChange = () => {
        setVisible(!visible);
    };

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar " justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start'>
                            <h3 className="title">Configuration</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                                <Breadcrumb.Item active>Configuration</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <Stack>
                            <Nav appearance="tabs" activeKey={activeKey} onSelect={handleNavSelect} style={{ display: 'flex', gap: '20px' }}>
                                <Nav.Item eventKey="content1"><b>Email Setting</b></Nav.Item>
                                <Nav.Item eventKey="content2"><b>Email Templates</b></Nav.Item>
                                <Nav.Item eventKey="content3"><b>WhatsApp</b></Nav.Item>
                                <Nav.Item eventKey="content4"><b>Link Generate</b></Nav.Item>
                            </Nav>
                        </Stack>
                    </Stack>

                    <Stack alignItems='flex-end'  >


                        <InputGroup inside >
                            <Input placeholder="Search" type="text" />
                            <InputGroup.Addon>
                                <SearchIcon />
                            </InputGroup.Addon>
                        </InputGroup>


                    </Stack>


                </Stack>
                <Divider className='divide' />

                <Panel className='row'>


                    {activeKey === 'content1' && (
                        <>
                            <Stack justifyContent='center'>
                                <Form>
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Username</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Password</Form.ControlLabel>
                                        <InputGroup inside >

                                            <Input type={visible ? 'text' : 'password'} />
                                            <InputGroup.Button onClick={handleChange}>
                                                {visible ? <EyeIcon /> : <EyeSlashIcon />}
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>SMTP Connection</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>
                                    <Form.Group>

                                    </Form.Group>
                                </Form>
                            </Stack>
                            <Stack justifyContent='flex-end'>
                                <Button appearance="primary" color='cyan'>Save</Button>
                            </Stack>
                        </>
                    )}
                    {activeKey === 'content2' && (
                        <>
                        <Stack>
                            <Nav appearance="tabs" activeKey={activeKey1} onSelect={handleNavSelect1} style={{ display: 'flex', gap: '20px' }}>
                                <Nav.Item eventKey="content1"><b>Template 1</b></Nav.Item>
                                <Nav.Item eventKey="content2"><b>Template 2</b></Nav.Item>
                                <Nav.Item eventKey="content3"><b>Template 3</b></Nav.Item>
                            </Nav>
                        </Stack>
                        {activeKey1 === 'content1' && (
                            <>
<Stack justifyContent='center'>
                                <Form>
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>To</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>

                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Cc</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Subject</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Body</Form.ControlLabel>
                                        <Input as="textarea" rows={3} placeholder="Textarea" />
                                    </Form.Group>
                                    
                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>Signature</Form.ControlLabel>
                                        <Form.Control name="name" />
                                    </Form.Group>
                                    <Form.Group>

                                    </Form.Group>
                                </Form>
                            </Stack>


                            </>
                        )}
                        </>
                    )}
                     {activeKey === 'content3' && (
                        <>
                        <Panel>

                        </Panel>
                        </>
                     )}
                     {activeKey === 'content4' && (
                        <>
                        <Panel>
                            
                        </Panel>
                        </>
                     )}

                </Panel>

                <Stack className="copyright"    justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERP Daddy Softwere Solution.</a></p>
                </Stack>
            </Container>
        </>
    );
};

export default MailConfig;